/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.input-right[_ngcontent-%COMP%] {\n  float: right; }\n\n.general-listing[_ngcontent-%COMP%] {\n  color: #ffffff;\n  background: #9c0c2b;\n  font-style: oblique;\n  padding: 2px 10px 2px 10px;\n  border-radius: 5px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvcHJvZmlsZS1zdXJ2ZWlzL3Byb2ZpbGUtc3VydmVpcy5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9lbXBsb3llZS9wYWdlcy9wcm9maWxlLXN1cnZlaXMvcHJvZmlsZS1zdXJ2ZWlzLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/profile-surveis/profile-surveis.component.scss.shim.ngstyle.ts